import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Layout
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import DonatePage from "@/pages/DonatePage";
import DonateSuccessPage from "@/pages/DonateSuccessPage";
import ContactPage from "@/pages/ContactPage";
import VolunteerPage from "@/pages/VolunteerPage";
import EventsPage from "@/pages/EventsPage";
import BlogPage from "@/pages/BlogPage";
import SpreadTheWordPage from "@/pages/SpreadTheWordPage";
import AdminPage from "@/pages/AdminPage";

// Analytics
import AnalyticsTracker from "@/components/AnalyticsTracker";

// Policy Pages
import HousingPage from "@/pages/policies/HousingPage";
import RentalPage from "@/pages/policies/RentalPage";
import CleanEnergyPage from "@/pages/policies/CleanEnergyPage";
import FoodDesertsPage from "@/pages/policies/FoodDesertsPage";
import HealthcarePage from "@/pages/policies/HealthcarePage";
import BailReformPage from "@/pages/policies/BailReformPage";
import ArbitrationPage from "@/pages/policies/ArbitrationPage";
import NDAReformPage from "@/pages/policies/NDAReformPage";
import AccountabilityPage from "@/pages/policies/AccountabilityPage";
import ProUnionPage from "@/pages/policies/ProUnionPage";
import ProWorkerPage from "@/pages/policies/ProWorkerPage";
import HealthInsurancePage from "@/pages/policies/HealthInsurancePage";
import FederalFundingPage from "@/pages/policies/FederalFundingPage";
import TNVPage from "@/pages/policies/TNVPage";
import ComingSoonPage from "@/pages/policies/ComingSoonPage";
import PostJusticePage from "@/pages/policies/PostJusticePage";
import AIDataCentersPage from "@/pages/policies/AIDataCentersPage";
import EducationPage from "@/pages/policies/EducationPage";
import AutomationPage from "@/pages/policies/AutomationPage";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AnalyticsTracker />
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/donate" element={<DonatePage />} />
            <Route path="/donate/success" element={<DonateSuccessPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/volunteer" element={<VolunteerPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/news" element={<BlogPage />} />
            <Route path="/spread-the-word" element={<SpreadTheWordPage />} />
            <Route path="/admin" element={<AdminPage />} />
            
            {/* Policy Pages */}
            <Route path="/policies/housing" element={<HousingPage />} />
            <Route path="/policies/rental" element={<RentalPage />} />
            <Route path="/policies/clean-energy" element={<CleanEnergyPage />} />
            <Route path="/policies/food-deserts" element={<FoodDesertsPage />} />
            <Route path="/policies/healthcare" element={<HealthcarePage />} />
            <Route path="/policies/bail-reform" element={<BailReformPage />} />
            <Route path="/policies/arbitration" element={<ArbitrationPage />} />
            <Route path="/policies/nda-reform" element={<NDAReformPage />} />
            <Route path="/policies/accountability" element={<AccountabilityPage />} />
            <Route path="/policies/pro-union" element={<ProUnionPage />} />
            <Route path="/policies/pro-worker" element={<ProWorkerPage />} />
            <Route path="/policies/health-insurance" element={<HealthInsurancePage />} />
            <Route path="/policies/federal-funding" element={<FederalFundingPage />} />
            <Route path="/policies/tnv" element={<TNVPage />} />
            <Route path="/policies/more-coming-soon" element={<ComingSoonPage />} />
            <Route path="/policies/post-justice" element={<PostJusticePage />} />
            <Route path="/policies/no-ai-subsidies" element={<AIDataCentersPage />} />
            <Route path="/policies/education" element={<EducationPage />} />
            <Route path="/policies/automation" element={<AutomationPage />} />

            {/* Short URL Redirects */}
            <Route path="/housing" element={<Navigate to="/policies/housing" replace />} />
            <Route path="/rent" element={<Navigate to="/policies/rental" replace />} />
            <Route path="/energy" element={<Navigate to="/policies/clean-energy" replace />} />
            <Route path="/food" element={<Navigate to="/policies/food-deserts" replace />} />
            <Route path="/healthcare" element={<Navigate to="/policies/healthcare" replace />} />
            <Route path="/nda" element={<Navigate to="/policies/nda-reform" replace />} />
            <Route path="/union" element={<Navigate to="/policies/pro-union" replace />} />
            <Route path="/post" element={<Navigate to="/policies/post-justice" replace />} />
            <Route path="/ai" element={<Navigate to="/policies/no-ai-subsidies" replace />} />
            <Route path="/education" element={<Navigate to="/policies/education" replace />} />
            <Route path="/automation" element={<Navigate to="/policies/automation" replace />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
